module.exports = __webpack_public_path__ + "static/media/emma-roberts-lose.df9c29ab.jpg";